const TIMEZONE = "Asia/Seoul";

export function formatMessageTime(dateStr) {
  if (!dateStr) return "";
  const date = new Date(dateStr);
  const timeStr = date.toLocaleTimeString("en-US", {
    timeZone: TIMEZONE,
    hour: "2-digit",
    hour12: true,
    minute: "2-digit",
  });
  const parts = timeStr.split(":");
  let h = parseInt(parts[0], 10);
  const m = (parts[1] || "00").slice(0, 2);
  const isAm = timeStr.includes("AM");
  const period = isAm ? "오전" : "오후";
  if (h === 0) h = 12;
  else if (h > 12) h -= 12;
  return `${period} ${h}:${m}`;
}


export function formatRoomTime(dateStr) {
  if (!dateStr) return "";

  const date = new Date(dateStr);
  const seoulDateStr = date.toLocaleDateString("ko-KR", {
    timeZone: TIMEZONE,
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
  });
  const todayStr = new Date().toLocaleDateString("ko-KR", {
    timeZone: TIMEZONE,
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
  });

  if (seoulDateStr === todayStr) {
    const timeStr = date.toLocaleTimeString("en-US", {
      timeZone: TIMEZONE,
      hour: "2-digit",
      hour12: true,
      minute: "2-digit",
    });
    const parts = timeStr.split(":");
    let h = parseInt(parts[0], 10);
    const m = (parts[1] || "00").slice(0, 2);
    const isAm = timeStr.includes("AM");
    const period = isAm ? "오전" : "오후";
    if (h === 0) h = 12;
    else if (h > 12) h -= 12;
    return `${period} ${h}:${m}`;
  }

  const month = date.toLocaleDateString("ko-KR", {
    timeZone: TIMEZONE,
    month: "numeric",
  });
  const day = date.toLocaleDateString("ko-KR", {
    timeZone: TIMEZONE,
    day: "numeric",
  });
  return `${month} ${day}`;
}
